import {Box, Typography} from "@mui/material";
import {formatDateLabel} from "../billingUtils";
import {useTranslation} from "react-i18next";

type BarChartTitleProps =
{
    cycleStart: string;
    selectedStartDate: string;
    cycleEnd: string;
    selectedEndDate: string;
}

export const BarChartTitle = (
    {
        cycleStart,
        selectedStartDate,
        cycleEnd,
        selectedEndDate}: BarChartTitleProps,
) => {
    const {t: translate} = useTranslation();

    return (
        <Box>
            <Typography
                sx={(theme) => ({
                    fontFamily: theme.typography.h4.fontFamily || theme.typography.fontFamily,
                    fontSize: 24,
                    fontWeight: 800,
                    color: theme.palette.text.primary,
                })}
            >
                {translate("admin.billing.chartTitle")}
            </Typography>
            <Typography color="text.secondary">
                {translate("admin.billing.chartRange", {
                    startDate: formatDateLabel(cycleStart || selectedStartDate, {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                    }),
                    endDate: formatDateLabel(cycleEnd || selectedEndDate, {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                    }),
                })}
            </Typography>
        </Box>
    );
};
